import { Module } from '../Module';
import { DataConnections } from '../resources/DataConnections';
import { FlowOutputStepRuns } from '../resources/FlowOutputStepRuns';
import { ContentFilterKeyName, ContentFiltersKeys } from './ContentFilters';
import { DataConnectionInFlowContentType, FlowOutputStepRunContentType } from './ContentTypes';
import { IPlace, Place, Subplace } from './IPlace';

export class FlowPlace {

  private static DataConnectionExcludeFilterKeys: ContentFilterKeyName[] = [
    ContentFiltersKeys.favorite,
    ContentFiltersKeys.flow,
    ContentFiltersKeys.hasAlert,
    ContentFiltersKeys.hasExtracts,
    ContentFiltersKeys.isCertified,
    ContentFiltersKeys.owner,
    ContentFiltersKeys.modifiedAfter,
    ContentFiltersKeys.modifiedBefore,
    ContentFiltersKeys.project,
    ContentFiltersKeys.showEmbedded,
    ContentFiltersKeys.tag,
  ];

  private static FlowRunHistoryExcludeFilterKeys: ContentFilterKeyName[] = [];

  public static $inject = [
    '$location',
    'DataConnections',
    'FlowOutputStepRuns'
  ];

  constructor(
    private $location: ng.ILocationService,
    private dataConnections: DataConnections,
    private flowOutputStepRuns: FlowOutputStepRuns
  ) {

  }

  public create(flowId: string): IPlace {
    const place = new Place('flow');

    place.addSubplace(Subplace.create(
      'connections',
      DataConnectionInFlowContentType,
      this.dataConnections,
      { flow: flowId },
      FlowPlace.DataConnectionExcludeFilterKeys)
    );

    place.addSubplace(Subplace.create(
      'runHistory',
      FlowOutputStepRunContentType,
      this.flowOutputStepRuns,
      { flow: flowId },
      FlowPlace.FlowRunHistoryExcludeFilterKeys)
    );

    return place;
  }

}

Module.instance().service('FlowPlace', FlowPlace);
